import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

import "./nossaEquipe.css";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import Whatsapp from "../../components/whatsapp/whatsapp";
import SEO from "../../components/seo/SEO";
import { getBreadcrumbSchema } from "../../utils/schemas";
import Advogado1 from "../../assets/images/advogado1.jpg";

function NossaEquipe() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const breadcrumbs = [
    { name: "Home", url: "https://antoniosaldanhaadvocacia.com.br/" },
    {
      name: "Nossa Equipe",
      url: "https://antoniosaldanhaadvocacia.com.br/nossa-equipe",
    },
  ];
  const advogados = [
    {
      id: 1,
      nome: "Antonio Saldanha",
      cargo: "Advogado",
      oab: "OAB/SP 498.576",
      foto: Advogado1,
      areas: [
        "Direito Trabalhista",
        "Direito Previdenciário",
        "Direito Cível",
        "Direito Empresarial",
        "Direito Penal",
        "Direito de Família",
      ],
      formacao: "Bacharel em Direito pela Universidade Nove de Julho",
      posGraduacao:
        "Pós Graduado em Direito Processual Penal pelo Damásio Educacional",
      bio: "Busco oferecer um atendimento próximo e transparente, entendendo as necessidades de cada cliente para encontrar as melhores soluções jurídicas para cada caso. Exerço a advocacia com seriedade e dedicação, sempre prezando pela ética, pelo respeito e pela confiança construída ao longo de cada relação profissional.",
    },
  ];

  const pilares = [
    {
      icone: (
        <svg
          width="32"
          height="32"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 6l3 13h12l3-13M3 6h18M3 6l2-3h14l2 3M12 3v3M9 13l2 2 4-4"
          />
        </svg>
      ),
      titulo: "Ética e Responsabilidade",
      texto:
        "Toda atuação do escritório é pautada na ética profissional, no respeito às normas da OAB e no compromisso com a integridade em cada etapa do processo.",
    },
    {
      icone: (
        <svg
          width="32"
          height="32"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      ),
      titulo: "Atendimento Individualizado",
      texto:
        "Cada demanda jurídica é tratada com atenção exclusiva. Analisamos com profundidade cada situação para oferecer a orientação mais adequada e estratégica.",
    },
    {
      icone: (
        <svg
          width="32"
          height="32"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
      ),
      titulo: "Comunicação Clara",
      texto:
        "Prezamos pela transparência em todas as etapas. Mantemos o cliente informado, de forma simples e direta, sobre o andamento e os desdobramentos do seu caso.",
    },
  ];

  return (
    <div className="container-fluid p-0 pagina-nossa-equipe">
      <SEO
        title="Nossa Equipe | Antonio Saldanha Advocacia"
        description="Conheça os profissionais da Antonio Saldanha Advocacia, sua formação, áreas de atuação e compromisso com a prestação responsável de serviços jurídicos."
        canonical="https://antoniosaldanhaadvocacia.com.br/nossa-equipe"
        schemaJson={getBreadcrumbSchema(breadcrumbs)}
      />

      <Navbar />

      <main className="py-4">
        <section
          className="container mt-4 d-flex flex-column align-items-center text-center"
          data-aos="fade-up"
          aria-labelledby="titulo-nossa-equipe"
        >
          <span className="badge badge-dourado mb-2">Conheça Nossa Equipe</span>
          <h1 className="titulos-secoes" id="titulo-nossa-equipe">
            Nossa Equipe
          </h1>
          <p className="equipe-lead mt-4 font-subtitulo text-secondary">
            Profissionais comprometidos com seus direitos
          </p>
          <p className="equipe-intro mt-2 text-secondary">
            O Antonio Saldanha Advocacia reúne profissionais dedicados à
            prestação de serviços jurídicos com ética, rigor técnico e atenção
            personalizada. Cada membro da equipe contribui com sua expertise
            para oferecer soluções estratégicas e responsáveis, respeitando as
            particularidades de cada cliente e demanda.
          </p>
        </section>

        <section
          className="container mt-5 equipe-wrapper"
          data-aos="fade-up"
          aria-labelledby="titulo-profissionais"
        >
          <div className="text-center mb-5">
            <h2 className="titulos-secoes" id="titulo-profissionais">
              Nossos Profissionais
            </h2>
          </div>

          <div className="row g-4 justify-content-center">
            {advogados.map((adv, index) => (
              <div
                className="col-12 col-lg-11 col-xl-10"
                key={adv.id}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <article className="card equipe-card border rounded-3 shadow-sm h-100 overflow-hidden">
                  <div className="row g-0 align-items-stretch h-100">
                    {/* Coluna de Destaque do Profissional (Foto + Credencial) */}
                    <div className="col-12 col-md-5 col-lg-4 equipe-col-foto">
                      <div className="equipe-foto-container">
                        <div className="equipe-moldura-foto">
                          {adv.foto ? (
                            <img
                              src={adv.foto}
                              alt={`Foto profissional de ${adv.nome}`}
                              className="equipe-foto-img"
                              loading="lazy"
                            />
                          ) : (
                            <div
                              className="equipe-foto-placeholder"
                              aria-label={`Foto de ${adv.nome} — a ser inserida`}
                            >
                              <span className="placeholder-monograma">AS</span>
                              <div className="placeholder-icone-wrapper">
                                <svg
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  viewBox="0 0 24 24"
                                  aria-hidden="true"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                                  />
                                </svg>
                              </div>
                              <span className="equipe-foto-texto mt-2">
                                Foto Profissional
                              </span>
                            </div>
                          )}
                          <div className="moldura-detalhe-dourado"></div>
                        </div>

                        {/* Selo Oficial OAB em Destaque abaixo da Foto */}
                        <div className="equipe-oab-wrapper mt-3 text-center">
                          <span className="badge-oab-destaque">
                            <svg
                              width="14"
                              height="14"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              className="me-1"
                              aria-hidden="true"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M3 6l3 13h12l3-13M3 6h18M3 6l2-3h14l2 3M12 3v3M9 13l2 2 4-4"
                              />
                            </svg>
                            {adv.oab}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Coluna de Informações e Textos */}
                    <div className="col-12 col-md-7 col-lg-8 equipe-col-conteudo">
                      <div className="equipe-card-content p-4 p-lg-5 h-100 d-flex flex-column">
                        <div className="mb-3">
                          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
                            <h3 className="fs-4 fw-bold mb-0 text-dark font-corpo">
                              {adv.nome}
                            </h3>
                            <span className="badge-cargo-destaque">
                              {adv.cargo}
                            </span>
                          </div>
                        </div>

                        <div className="divisor-dourado-suave my-3"></div>

                        {adv.areas && adv.areas.length > 0 && (
                          <div className="mb-3">
                            <p className="font-xs fw-semibold text-uppercase text-muted mb-2 letter-spacing-1">
                              Áreas de Atuação
                            </p>
                            <div className="d-flex flex-wrap gap-1">
                              {adv.areas.map((area, i) => (
                                <span
                                  key={i}
                                  className="badge-area d-inline-block"
                                >
                                  {area}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}

                        <div className="mb-3">
                          <p className="font-xs fw-semibold text-uppercase text-muted mb-1 letter-spacing-1">
                            Formação Acadêmica
                          </p>
                          <p className="font-sm text-secondary mb-1">
                            {adv.formacao}
                          </p>
                          {adv.posGraduacao && (
                            <p className="font-xs text-terciario mb-0 fst-italic">
                              {adv.posGraduacao}
                            </p>
                          )}
                        </div>

                        <div
                          className="mt-auto pt-3 border-top"
                          style={{ borderColor: "var(--cor-borda-suave)" }}
                        >
                          <p className="texto-bio font-sm mb-0">{adv.bio}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </section>

        <section
          className="container mt-5 mb-4"
          data-aos="fade-up"
          aria-labelledby="titulo-como-trabalhamos"
        >
          <div className="text-center mb-5">
            <h2 className="titulos-secoes" id="titulo-como-trabalhamos">
              Como Trabalhamos
            </h2>
          </div>

          <div className="row g-4 justify-content-center">
            {pilares.map((pilar, index) => (
              <div
                className="col-12 col-sm-6 col-lg-4"
                key={index}
                data-aos="zoom-in"
                data-aos-delay={100 + index * 100}
              >
                <div className="card card-diferencial h-100 border-0 p-4 text-center rounded-3 shadow-sm">
                  <div className="icone-diferencial mb-3">
                    <span className="text-dourado">{pilar.icone}</span>
                  </div>
                  <h3 className="fs-5 fw-semibold mb-2">{pilar.titulo}</h3>
                  <p className="text-muted small mb-0">{pilar.texto}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section
          className="container mt-5 mb-4"
          data-aos="fade-up"
          aria-labelledby="titulo-cta-equipe"
        >
          <div className="cta-equipe rounded-3 p-4 p-md-5 text-center">
            <span className="badge badge-dourado mb-3">
              Fale com Nossa Equipe
            </span>
            <h2
              className="fs-2 fw-bold mb-3 font-titulo"
              id="titulo-cta-equipe"
              style={{ color: "var(--cor-texto-escuro-principal)" }}
            >
              Pronto para tirar suas dúvidas?
            </h2>
            <p
              className="mb-4 mx-auto font-subtitulo"
              style={{
                maxWidth: "580px",
                color: "var(--cor-texto-escuro-suave)",
              }}
            >
              Nossa equipe está à disposição para orientar você sobre suas
              demandas jurídicas. Entre em contato pelo WhatsApp ou conheça
              nossas áreas de atuação.
            </p>
            <div className="d-flex flex-wrap gap-3 justify-content-center">
              <a
                href="https://wa.me/5511954242066"
                target="_blank"
                rel="noopener noreferrer"
                className="btn botao-dourado"
                aria-label="Abrir conversa no WhatsApp com Antonio Saldanha Advocacia"
              >
                Falar pelo WhatsApp
              </a>
              <Link to="/#areas" className="btn botao-escuro-padrao">
                Áreas de Atuação
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  );
}

export default NossaEquipe;
